import { createContext, useContext } from 'react';
import { ChainIds } from '@sovryn/ethers-provider';
import { noop } from '@sovryn/ui';
export var ReceiveFlowStep;
(function (ReceiveFlowStep) {
    ReceiveFlowStep[ReceiveFlowStep["INITIAL"] = 0] = "INITIAL";
    ReceiveFlowStep[ReceiveFlowStep["MAIN"] = 1] = "MAIN";
    ReceiveFlowStep[ReceiveFlowStep["AMOUNT"] = 2] = "AMOUNT";
    ReceiveFlowStep[ReceiveFlowStep["REVIEW"] = 3] = "REVIEW";
    ReceiveFlowStep[ReceiveFlowStep["PROCESSING"] = 4] = "PROCESSING";
    ReceiveFlowStep[ReceiveFlowStep["COMPLETED"] = 5] = "COMPLETED";
})(ReceiveFlowStep || (ReceiveFlowStep = {}));
export var AddressValidationState;
(function (AddressValidationState) {
    AddressValidationState["NONE"] = "NONE";
    AddressValidationState["LOADING"] = "LOADING";
    AddressValidationState["VALID"] = "VALID";
    AddressValidationState["INVALID"] = "INVALID";
})(AddressValidationState || (AddressValidationState = {}));
export const defaultValue = {
    step: ReceiveFlowStep.INITIAL,
    amount: '',
    receiver: '',
    chain: ChainIds.MAINNET,
    asset: undefined,
    set: noop,
    chainId: undefined,
    token: undefined,
};
export const ReceiveFlowContext = createContext(defaultValue);
export const useReceiveFlowContext = () => {
    return useContext(ReceiveFlowContext);
};
